/**
 * User Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    const BaseReplacerView = require('common/base.replacer.view');
    const user = require('user');

    /**
     * Names of replacers
     */
    var USER_NAME_REPLACER = 'USER_NAME',
        USER_CURRENCY_REPLACER = 'USER_CURRENCY';

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        render: function() {
            var name = this.options.name;

            if (name === 'username') {
                this._renderName();
            } else if (name === 'usercurrency') {
                this._renderCurrency();
            }

            return this;
        },

        _renderName: function() {
            this.$el.html(user.get('userName'));
        },

        _renderCurrency: function() {
            this.$el.html(window.Playtech.API.formatter.getCurrencySymbol());
        }

    }, {
        nameOfReplacers: [
            USER_NAME_REPLACER,
            USER_CURRENCY_REPLACER
        ]
    });
});
